<template>
  <div class="subscription-settings">
    <component v-bind:is="stateToComponentMapping[subscriptionState]"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TrialSettings from './TrialSettings.vue';
import DormantAfterTrialSettings from './DormantAfterTrialSettings.vue';
import SubscribedSettings from './SubscribedSettings.vue';
import CanceledSettings from './CanceledSettings.vue';
import FreeSubscriptionSettings from './FreeSubscriptionSettings.vue';
import OnboardingSettings from './OnboardingSettings.vue';
import Segment from '../../../../../Segment';
import { SUBSCRIPTION_STATES } from '../../../../../constants/subscription-state';

export default {
  name: 'SubscriptionSettings',
  components: {
    TrialSettings,
    DormantAfterTrialSettings,
    SubscribedSettings,
    CanceledSettings,
    FreeSubscriptionSettings,
    OnboardingSettings,
  },
  data() {
    return {
      stateToComponentMapping: {
        [SUBSCRIPTION_STATES.FREE]: FreeSubscriptionSettings,
        [SUBSCRIPTION_STATES.PRE_TRIAL]: OnboardingSettings,
        [SUBSCRIPTION_STATES.TRIAL]: TrialSettings,
        [SUBSCRIPTION_STATES.SUBSCRIBED]: SubscribedSettings,
        [SUBSCRIPTION_STATES.CANCELED]: CanceledSettings,
        [SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL]: DormantAfterTrialSettings,
        [SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED]: CanceledSettings,
      },
    };
  },
  created() {
    Segment.trackUserGot('SubscriptionSettingsEntered', { subscriptionState: this.subscriptionState });
  },
  computed: {
    ...mapState('subscriptionState', ['subscriptionState']),
  },
};
</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .subscription-settings {
    background-color: $riseup_white;
    box-shadow: 0 0 6px 0 $riseup_gray_1;
    border-radius: 5px;
    margin-bottom: 14px;
  }

</style>
